import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const HeroSection = ({ onApplyClick }) => {
  const { hero } = mockData;
  const [badgeRef, badgeVisible] = useScrollAnimation();
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [subtitleRef, subtitleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [buttonsRef, buttonsVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#5F9BC7]/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#FFE7AB]/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-b from-transparent via-[#5F9BC7]/5 to-transparent"></div>
      </div>

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(95,155,199,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(95,155,199,0.03)_1px,transparent_1px)] bg-[size:72px_72px]"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-8 md:py-20">
        <div className="max-w-5xl mx-auto text-center">
          {/* Badge */}
          <div 
            ref={badgeRef}
            className={`scroll-animate fade-in-bottom ${badgeVisible ? 'visible' : ''} inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#5F9BC7]/10 border border-[#5F9BC7]/30 backdrop-blur-sm mb-8 mt-16 md:mt-0`}
          >
            <Zap className="w-4 h-4 text-[#5F9BC7]" />
            <span className="text-sm font-medium text-[#5F9BC7]">Transform Your Body & Life</span>
          </div>

          {/* Main Tagline */}
          <h1 
            ref={titleRef}
            className={`scroll-animate fade-in-bottom stagger-1 ${titleVisible ? 'visible' : ''} text-5xl md:text-7xl font-bold mb-6 leading-tight`}
          >
            <span className="text-white">{hero.tagline}</span>
          </h1>

          {/* Subtitle */}
          <p 
            ref={subtitleRef}
            className={`scroll-animate fade-in-bottom stagger-2 ${subtitleVisible ? 'visible' : ''} text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed`}
          >
            {hero.subtitle}
          </p>

          {/* CTA Buttons */}
          <div 
            ref={buttonsRef}
            className={`scroll-animate fade-in-bottom stagger-3 ${buttonsVisible ? 'visible' : ''} flex flex-col sm:flex-row items-center justify-center gap-4`}
          >
            <Button
              onClick={onApplyClick}
              size="lg"
              className="group bg-gradient-to-r from-[#5F9BC7] to-[#4A8AB0] hover:from-[#4A8AB0] hover:to-[#5F9BC7] text-white px-8 py-6 text-lg rounded-xl font-semibold shadow-2xl shadow-[#5F9BC7]/40 transition-all duration-300 hover:shadow-[#5F9BC7]/60 hover:scale-105"
            >
              {hero.ctaText}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
            <Button
              onClick={() => document.getElementById('method').scrollIntoView({ behavior: 'smooth' })}
              size="lg"
              variant="outline"
              className="px-8 py-6 text-lg rounded-xl font-semibold border-2 border-[#5F9BC7]/50 text-[#5F9BC7] hover:bg-[#5F9BC7]/10 hover:border-[#5F9BC7] transition-all duration-300"
            >
              Learn More
            </Button>
          </div>

          {/* Fat Loss Blueprint Indicator */}
          <p className="text-[#FFE7AB] text-base md:text-lg mt-8 font-medium animate-pulse">
            Looking for the Free Fat Loss Blueprint? Scroll down 👇
          </p>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
